module.exports = __webpack_public_path__ + "img/customer_06.d8fa03cc.jpg";